/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../utils/constants';
import createIcon from '~/src/static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function UsersList(): JSX.Element {
  const stateRef = useRef(null);
  const url = `${API_URL}/users/get`;
  const history = useHistory();
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/users/edit/${dataItem.id}`}>{dataItem?.firstName}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Users"
        titleRight="Create"
        onRightHandler={(): void => history.push('/users/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="firstName" title="First Name" cell={(row) => productNameCell(row, stateRef)} />
          <GridColumn field="lastName" title="Last Name" />
          <GridColumn field="isDisabled" title="is Disabled" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
